import { useEffect, useState } from "react";
import axios from "axios";
import { Flame } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SeatsLeft = () => {
  const [seats, setSeats] = useState(null);

  useEffect(() => {
    const fetchSeats = () => axios.get(`${API}/seats`).then((r) => setSeats(r.data.seatsLeft)).catch(() => {});
    fetchSeats();
    const id = setInterval(fetchSeats, 30000);
    return () => clearInterval(id);
  }, []);

  if (seats === null) return null;

  return (
    <div className="inline-flex items-center gap-2 px-3.5 py-2.5 border" style={{ borderColor: "rgba(124,58,237,0.4)", background: "rgba(124,58,237,0.07)" }} data-testid="seats-left-badge">
      <Flame size={15} style={{ color: "#2FA043" }} />
      <span className="font-mono-c font-bold text-[13px] tracking-[0.12em]" style={{ color: "#6D28D9" }} data-testid="seats-left-count">
        ONLY {seats} SEATS LEFT
      </span>
    </div>
  );
};
